<template>
    <div class="wrap">
        <listHeader
            :title="postData.lid > 0 ? '编辑课程库' : '新增课程库'"
            :back="true"></listHeader>

        <div class="wrap-list-content">

            <hro-tab
                scenario="lesson"
                active="info"
                :lid="postData.lid"
            ></hro-tab>

            <div class="wrap-form-info">
                <a-row>
                    <a-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
                        <a-form :form="form">

                            <a-form-item
                                label="课程库名称"
                                v-bind="formItemLayout"
                                required
                            >
                                <a-input placeholder="请输入课程库名称" v-decorator="['lname', {rules: [{ required: true, max: 64, message: '请输入课程库名称' }], initialValue: ''}]"/>
                            </a-form-item>

                            <a-form-item
                                v-bind="formBtnLayout"
                            >
                                <a-button type="primary" @click="create">确定</a-button>
                            </a-form-item>
                        </a-form>
                    </a-col>
                </a-row>
            </div>
        </div>
    </div>
</template>

<script>
import listHeader from '@/components/list/listHeader';
import hroTab from '@/components/list/tab';

export default {
    components: {
        listHeader,
        hroTab
    },
    data() {
        return {
            scenario: 'lessonCreate',
            visible: false, // 是否显示图片src
            formItemLayout: {
                labelCol: {
                    span: 5
                },
                wrapperCol: {
                    span: 19
                },
            },
            formBtnLayout: {
                wrapperCol: {
                    span: 19,
                    offset: 5,
                },
            },
            form: this.$form.createForm(this),
            postData: {
                'lid': '',
            },
            data: {},
            config: {},
        }
    },
    Watch: {
    },
    created() {
        this.setData();
        this.getData();
    },
    methods: {
        setData() {
            for (let i in this.postData) {
                if (this.$route.query[i] === undefined) continue;
                this.postData[i] = this.$route.query[i];
            }
        },
        getData() {
            // 查询数据
            this.http('/manage/lesson/info', this.postData, (res) => {
                this.data = res.data;
                this.config = res.config;

                if (res.data.lid) {
                    this.$nextTick(() => {
                        this.form.setFieldsValue({
                            lname: res.data.lname,
                        });
                    });
                }

            }, null, 2);
        },
        create() {
            this.form.validateFields(
                (errors, values) => {
                    if (!errors) {
                        let url = '';
                        if(this.postData.lid > 0) {
                            url = '/manage/lesson/edit';

                            values.lid = this.postData.lid;
                        } else {
                            url = '/manage/lesson/save';
                        }

                        this.http(url, values, (res) => {
                            this.toast({content: '操作成功'}, (res) => {
                                if (this.postData.lid == '') {
                                    this.$router.go(-1);
                                } else {
                                    this.getData();
                                }
                            });
                        }, null, 1);
                    }
                }
            );
        },
    },
}
</script>

<style lang="less" src="../../assets/css/add/add.less"></style>
